import { call, put, takeLatest } from "redux-saga/effects"
import * as gql from "../../../common/graphql"
import {
  COMMON_FETCH_CODETABLES_BEGIN,
  COMMON_FETCH_CODETABLES_DISMISS_ERROR,
  COMMON_FETCH_CODETABLES_FAILURE,
  COMMON_FETCH_CODETABLES_SUCCESS,
} from "./constants"

export function fetchCodeTables() {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: COMMON_FETCH_CODETABLES_BEGIN,
  }
}

export function dismissFetchCodeTablesError() {
  return {
    type: COMMON_FETCH_CODETABLES_DISMISS_ERROR,
  }
}

// worker Saga: will be fired on COMMON_FETCH_CODETABLES_BEGIN actions
export function* doFetchCodeTables() {
  const { data, graphqlErrors, networkError } = yield call(gqlFetchCodeTables)
  if (data) {
    yield put({
      type: COMMON_FETCH_CODETABLES_SUCCESS,
      data,
    })
  } else {
    yield put({
      type: COMMON_FETCH_CODETABLES_FAILURE,
      data: { error: { graphqlErrors, networkError } },
    })
  }
}

function gqlFetchCodeTables() {
  return gql.post({
    queryName: "fetchCodeTables",
    query: `query fetchCodeTables {
      codeTables {
        unitTypes {
          entries {
            code
            titleDe
            titleFr
            titleIt
            titleEn
          }
        }

        trades {
          entries {
            code
            titleDe
            titleFr
            titleIt
            titleEn
          }
        }

        damageCaseDefaultTexts {
          entries {
            code
            titleDe
            titleFr
            titleIt
            titleEn
            descriptionDe
            descriptionFr
            descriptionIt
            descriptionEn
          }
        }
      }
    }`,
  })
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchFetchCodeTables() {
  yield takeLatest(COMMON_FETCH_CODETABLES_BEGIN, doFetchCodeTables)
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case COMMON_FETCH_CODETABLES_BEGIN:
      return {
        ...state,
        fetchCodeTablesPending: true,
        fetchCodeTablesError: null,
      }

    case COMMON_FETCH_CODETABLES_SUCCESS:
      return {
        ...state,
        ...action.data,
        fetchCodeTablesPending: false,
        fetchCodeTablesError: null,
      }

    case COMMON_FETCH_CODETABLES_FAILURE:
      return {
        ...state,
        fetchCodeTablesPending: false,
        fetchCodeTablesError: action.data.error,
      }

    case COMMON_FETCH_CODETABLES_DISMISS_ERROR:
      return {
        ...state,
        fetchCodeTablesError: null,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/fetchCodeTables.js